import React from "react";

export interface PinProps {
  href: string;
  label: string;
  children: React.ReactNode;
  className?: string;
}

const Pin: React.FC<PinProps> = ({
  href,
  label,
  children,
  className = "",
}) => {
  return (
    <a
      href={href}
      aria-label={label}
      target="_blank"
      rel="noopener noreferrer"
      className={`
        relative
        w-10 h-10
        rounded-full
        bg-[#f5f1e8]
        shadow-md
        flex items-center justify-center
        transition-transform
        hover:scale-105
        focus-visible:outline-none
        focus-visible:ring-2
        focus-visible:ring-yellow-400
        ${className}
      `}
    >
      {children}
      <span
        aria-hidden
        className="
          absolute -top-1 left-1/2 -translate-x-1/2
          w-2 h-2 rounded-full
          bg-pink-500
          shadow-sm
        "
      />
    </a>
  );
};

export default Pin;
